import _m from './mappings';
import _u from './util';
import _v from './vars';
import _fn from './shared-fn';
import callSalApi from './api-query';
import createGraph from  './line-graph';

let slotRenderBound = false;

/*
function renderBomDrivers() {			
	fetch('/physician-salary-explorer/noscan/bom.json')
	.then(res => {
		return res.json();
	})
		.then(function(json) {
			let bomArr = json[Object.keys(json)[0]];
			bomArr.forEach(function(obj, idx) {
				if (document.querySelectorAll('.bom-plchldr').length > 0) {
					let bomLink = document.createElement('a');
					bomLink.href = obj.uri;
					bomLink.setAttribute('onclick',"wmdTrack('mse-bom_ar" + (idx+1) + "')");
					bomLink.innerHTML = '<div class="slry-card bom"><div class="slry-card-ribbon"></div><div class="slry-card-thumb-wrap"><img class="slry-card-thumb" src="' + obj.thumb.replace('http:','https:') + '" /></div><div class="slry-card-supertitle">Medscape Business of Medicine</div><div class="slry-card-title">' + obj.ti + '</div></div>';
					document.querySelectorAll('.bom-plchldr')[0].parentNode.replaceChild(bomLink, document.querySelectorAll('.bom-plchldr')[0]);
				}
			});
		})
	.catch(err => {
	  console.log(err);
	});
}
*/

function selectJobKeys(json) {	
	let keyArr = [];
	if (Object.keys(json).length > 3) {		
		keyArr = _u.getRandomArr(Object.keys(json), 3);
	} else {
		keyArr = Object.keys(json);
	}
	return keyArr;
}

function renderJobWidget() {			
	fetch('https://www.medjobnetwork.com/main/js/jsonSearchResult?featured=true&location=' + _m.stateName[_v.userState] + '&limit=20&specialty_id=' + _v.homePageId)
	.then(res => {
		return res.json();
	})
		.then(function(json) {
			_u.qS('.slry-card.jobs').classList.remove('active');
			_u.qS('.job-listing-wrap').innerHTML = '';
			
			if (Object.keys(json).length > 0) {					
				let keyArr = selectJobKeys(json);
				keyArr.forEach(function(key, idx) {
					let jobLink = document.createElement('a');
					jobLink.className = 'job-listing';
					jobLink.href = json[key].job_url;
					jobLink.setAttribute('target', '_blank');
					jobLink.setAttribute("onclick", "wmdPageLink('mse-mjn_ar" + (idx+1) + "', this)");
					jobLink.innerHTML = '<div class="job-title">' + json[key].job_title + '</div><div class="job-desc">' + json[key].employer_name + '</div><div class="job-desc">' + json[key].state.replace(/ \([A-Z][A-Z]\)$/,'') + '</div>';
					_u.qS('.job-listing-wrap').appendChild(jobLink);
				});
				_u.qS('.jobs .slry-card-view-more').href = 'https://www.medjobnetwork.com' + _m.specMap[_v.homePageId].jobUrl;
				_u.qS('.slry-card.jobs').classList.add('active');					
			}
		})
	.catch(err => {
	  console.log(err);
	  
	 _u.qS('.slry-card.jobs').classList.remove('active');
	 _u.qS('.job-listing-wrap').innerHTML = '';		
	  // document.dispatchEvent(new CustomEvent('loadWidget'));		
	});		
}

function prepLg(e) {			
	let lowIndex = 0;
	let highIndex = 3;
	let grphIdx  = null;
	if (_v.userYoeIdx == 0) {
		lowIndex = 0;					
		if (breakpoint < 3) {
			highIndex = 2;
		} else {
			highIndex = 3;
		}
	} else if (_v.userYoeIdx >= _u.qS('.slry-lg-yoe-lbl').length - 2 ) {
		highIndex = 5;	
		if (breakpoint < 3) {
			lowIndex = 3;
		} else {
			lowIndex = 2;
		}
	} else {
		lowIndex = _v.userYoeIdx - 1;	
		if (breakpoint < 3) {
			highIndex = _v.userYoeIdx + 1;
		} else {
			highIndex = _v.userYoeIdx + 2;
		}
	}	
	_u.qS('.slry-lg-yoe-lbl').forEach((el) => {
		el.classList.remove('active');
	});
	for (var x = lowIndex; x <= highIndex; x++) {
		_u.qS('.slry-lg-yoe-lbl')[x].classList.add('active');
	}	
	_u.qS('.yoe-label-wrap').forEach(function(elem) {
		elem.classList.remove('inactive');
	});
	
	grphIdx = _v.userYoeIdx - lowIndex;
	
	if (_v.widgData['avgSalGrowth'] != null) {		
		_u.qS('.slry-card.growth').classList.remove('inactive');
		
		if (!_v.labelsAppended) {
			_v.labelsAppended = true;
			_fn.getLabelsGeneric();
		}			
		_fn.getLabels(_u.qS('.slry-card.growth'), _v.widgData['avgSalGrowth'].level);
		
		let avgGrowthArr = _v.widgData['avgSalGrowth'].metrics;
		let resSals = [];	
		for (var x = lowIndex; x <= highIndex; x++) {
			Object.keys(avgGrowthArr[x]).forEach((key) => {
				resSals.push(avgGrowthArr[x][key].average);
			});
		}
		
		createGraph(resSals, grphIdx, e);
		
		window.removeEventListener('resize', prepLg);
		window.addEventListener('resize', prepLg);
	}
	else {
		_u.qS('.slry-card.growth').classList.add('inactive');
	}
}

function handleViewMore() {
	let self = this;
	let rank = null;
	let currWidg = '';
	if (this.parentNode.classList.contains('specs')) {
		currWidg = 'specs';
		rank = _v.userSpecRank;
	} else if (this.parentNode.classList.contains('locs')) {
		currWidg = 'locs';
		rank = _v.userDmaRank;
	}
	
	this.parentNode.classList.add('expanding');
	setTimeout(function() {
		self.parentNode.classList.remove('expanding');
		document.dispatchEvent(new CustomEvent('heightChange'));
	}, 340);
	
	if (this.parentNode.classList.contains('expanded')) {
		this.parentNode.classList.remove('expanded');
		if (rank == null || rank <= 5) {
			this.parentNode.querySelector('.slry-card-high-item-self').classList.add('inactive');
			this.parentNode.classList.add('all');
		}
		else {
			this.parentNode.querySelector('.slry-card-high-item-self').classList.remove('inactive');
			this.parentNode.classList.remove('all');
		}
		
		if (currWidg == 'specs') {
			_u.wmdPageLink('mse-hps_less', this);
		} else if (currWidg == 'locs') {
			_u.wmdPageLink('mse-bpc_less', this);
		}
	}
	else {
		this.parentNode.classList.add('expanded');
		if (rank == null || rank <= 9) {
			this.parentNode.querySelector('.slry-card-high-item-self').classList.add('inactive');
			this.parentNode.classList.add('all');
		}
		else {
			this.parentNode.querySelector('.slry-card-high-item-self').classList.remove('inactive');
			this.parentNode.classList.remove('all');
		}
		
		if (currWidg == 'specs') {
			_u.wmdPageLink('mse-hps_more', this);
		} else if (currWidg == 'locs') {
			_u.wmdPageLink('mse-bpc_more', this);
		}
	}
}

function followScroll(e) {	
	if (typeof e.slot != 'undefined' && document.querySelectorAll('.adsHeight').length > 0) {
		document.querySelectorAll('.adsHeight').forEach((elem) => {
			elem.removeAttribute('style');
			elem.classList.remove('adsHeight');
		});
	}
	if (_v.scrollElem != null && !_v.isScrolling) {
		let currScrl = window.innerHeight - _v.scrollElem.elem.getBoundingClientRect().top;
		if (Math.abs(window.pageYOffset - (window.pageYOffset + (_v.scrollElem.fromBottom - currScrl))) > 50) {
			window.scrollTo(0, window.pageYOffset + (_v.scrollElem.fromBottom - currScrl));
		}
	}
}

function postWidgLoad() {
	if (_v.pendingLoad < 1) {
		_v.apiPending = false;		
		setTimeout(function() {
			_v.scrollElem = null;
		}, 2000);
		document.removeEventListener('loadWidget', followScroll);
		window.removeEventListener('collapse', followScroll);		
		document.dispatchEvent(new CustomEvent('allWidgetsLoaded'));
	}
}

let widgetInView = {};
let lastVis = {};

function checkWidgetsInView() {
	if (Object.keys(widgetInView).length == 0) {
		window.removeEventListener('scroll', checkWidgetsInView);
	}
	Object.keys(widgetInView).forEach(function(key) {
		let elem = _u.qS('#' + key);
		lastVis[key] = widgetInView[key];
		if (elem.offsetParent != null && (elem.getBoundingClientRect().top + elem.getBoundingClientRect().height/1.85) < window.innerHeight && (elem.getBoundingClientRect().bottom - elem.getBoundingClientRect().height/1.85) >= 0) {
			widgetInView[key] = true;
		} else {
			widgetInView[key] = false;
		}
		if (widgetInView[key] != lastVis[key] && widgetInView[key]) {
			elem.dispatchEvent(new CustomEvent('inView'));
			delete widgetInView[key];
		}
	});
}

function animateGender() {
	_u.qS('#avgBreakDownGender').removeEventListener('inView', animateGender);
	let genderRatio = 1;
	if (_v.widgData['avgBreakDownGender'].male.avg_salary > _v.widgData['avgBreakDownGender'].female.avg_salary) {
		genderRatio = _v.widgData['avgBreakDownGender'].female.avg_salary/_v.widgData['avgBreakDownGender'].male.avg_salary;
		_u.qS('.male .slry-card-gender-bar').style.height = '100%';
		_u.qS('.female .slry-card-gender-bar').style.height = Math.round(genderRatio*100) + '%';
	} else {
		genderRatio = _v.widgData['avgBreakDownGender'].male.avg_salary/_v.widgData['avgBreakDownGender'].female.avg_salary;
		_u.qS('.female .slry-card-gender-bar').style.height = '100%';
		_u.qS('.male .slry-card-gender-bar').style.height = Math.round(genderRatio*100) + '%';
	}
}

function animatePractice() {
	_u.qS('#avgBreakDownPractice').removeEventListener('inView', animatePractice);
	_u.qS('#avgBreakDownPractice').classList.add('active');	
}

function animateTopSpecialty() {
	_u.qS('#topSalarySpecialty').removeEventListener('inView', animateTopSpecialty);
	_u.qS('#topSalarySpecialty').classList.add('active');	
}

function animateTopIndividuals() {
	_u.qS('#topSalaryIndividuals').removeEventListener('inView', animateTopIndividuals);
	_u.qS('#topSalaryIndividuals').classList.add('active');	
}

function animateTopCities() {
	_u.qS('#topSalaryDmac').removeEventListener('inView', animateTopCities);
	_u.qS('#topSalaryDmac').classList.add('active');	
}

function renderWidgets(widget) {
	if (widget == 'avgLikeYou') {		
		// AVERAGE LIKE YOU	
		_u.qS('.slry-bar-graph-label-wrap').classList.remove('active');			
		_u.qS('.slry-bar-graph-bar').forEach(function(elem) {
			if (elem.querySelector('.slry-bar-graph-pct') != null) {
				elem.querySelector('.slry-bar-graph-pct').classList.remove('active');
			}
		});	
		_u.qS('.slry-avg-salary, .slry-avg-salary-byline, .slry-bar-graph-label-wrap').forEach(function(elem) {
			elem.classList.remove('active');
		});
	
		if (_v.widgData[widget] != null) {
			_u.qS('.slry-avg-like-you').classList.remove('inactive');
		
			if (!_v.labelsAppended) {
				_v.labelsAppended = true;
				_fn.getLabelsGeneric();
			}
			_fn.getLabels(_u.qS('.slry-avg-like-you'), _v.widgData[widget].level);
		
			_u.qS('.slry-avg-salary').innerHTML = _fn.formatSalary(_v.widgData[widget].avg_salary).split('$')[1];
			
			let salRatio = 0;
			if (typeof _v.widgData[widget].nationalPct != 'undefined') {
				salRatio = _v.widgData[widget].nationalPct;
			}
				
			if (salRatio == 0) {
				_u.qS('.slry-avg-salary-compare-wrap').innerHTML = '<span class="slry-avg-salary-compare same">About the same</span> as';
			} else if (salRatio > 0) {
				_u.qS('.slry-avg-salary-compare-wrap').innerHTML = '<span class="slry-avg-salary-compare higher">' + salRatio + '% higher</span> than';
			} else {
				_u.qS('.slry-avg-salary-compare-wrap').innerHTML = '<span class="slry-avg-salary-compare lower">' + Math.abs(salRatio) + '% lower</span> than';	
			}
			
			let pctArr = [];
			let labelArr = [];
			
			_v.widgData[widget].metrics.forEach(function(salObj,idx) {
				let resIdx = idx;
				Object.keys(salObj).forEach(function(key, idx) {				
					let graphBar = _u.qS('.slry-bar-graph-bar')[resIdx];
					graphBar.innerHTML = '<div class="slry-bar-graph-pct">' + salObj[key].pct + '%</div>';
					graphBar.querySelector('.slry-bar-graph-pct').classList.add('active');
					pctArr.push(Number(salObj[key].pct.replace('<1','0')));
					
					let minSal = String(Math.round(salObj[key].minSalary / 1000) * 1000);
					if (minSal.length == 5) {
						minSal = minSal.substring(0, 2);
					} else if (minSal.length == 7) {							
						minSal = minSal.substring(0, 4);							
					} else {							
						minSal = minSal.substring(0, 3);
					}
					let maxSal = String(Math.round(salObj[key].maxSalary / 1000) * 1000);
					if (maxSal.length == 5) {
						maxSal = maxSal.substring(0, 2);
					} else if (maxSal.length == 7) {							
						maxSal = maxSal.substring(0, 4);							
					} else {							
						maxSal = maxSal.substring(0, 3);
					}
					
					labelArr.push('$' + minSal + 'K - $' + maxSal + 'K');								
				})
			})
			
			labelArr.forEach(function(label,idx) {
				_u.qS('.slry-bar-graph-label')[idx].innerHTML = label;
			});
			
			let pctArrSort = pctArr.slice();
			pctArrSort.sort(function(a, b) {
				return a - b
			});
			let highPct = pctArrSort[pctArrSort.length - 1];
			let pctRatio = 100/highPct;
			
			pctArr.forEach(function(pct, idx) {
				if (pct == 0) {
					_u.qS('.slry-bar-graph-bar')[idx].style.height = '1px';
				} else {
					_u.qS('.slry-bar-graph-bar')[idx].style.height = (pct*pctRatio) + '%';
				}
			});
			
			_u.qS('.slry-avg-salary, .slry-avg-salary-byline, .slry-bar-graph-label-wrap').forEach(function(elem) {
				elem.classList.add('active');
			});
		
		}
		else {
			_u.qS('.slry-avg-like-you').classList.add('inactive');
		}

	}
	else if (widget == 'avgSalGrowth') {
		// AVERAGE SALARY GROWTH	
		prepLg();
	}
	else if (widget == 'avgBreakDownPractice') {
		// PRACTICE SETTING BREAKDOWN
		_u.qS('.slry-card-employ-circle').forEach((elem) => {
			elem.classList.remove('active');
		});
		if (_v.userEmp == 'Employed') {	
			_u.qS('.employed .slry-card-employ-circle').classList.add('active');
		} else if  (_v.userEmp == 'Self-employed') {
			_u.qS('.self .slry-card-employ-circle').classList.add('active');
		}
		
		if (_v.widgData[widget] != null && _v.widgData[widget].employed.avg_salary != null && _v.widgData[widget].selfemployed.avg_salary != null) {
			_u.qS('#' + widget).classList.remove('inactive');
			
			if (!_v.labelsAppended) {
				_v.labelsAppended = true;
				_fn.getLabelsGeneric();
			}
			_fn.getLabels(_u.qS('#' + widget), _v.widgData[widget].level);
						
			_u.qS('.employed .slry-card-employ-salary').innerHTML = _fn.formatSalary(_v.widgData[widget].employed.avg_salary);
			_u.qS('.self .slry-card-employ-salary').innerHTML = _fn.formatSalary(_v.widgData[widget].selfemployed.avg_salary);
			
			widgetInView[widget] = false;
			_u.qS('#' + widget).removeEventListener('inView', animatePractice);
			_u.qS('#' + widget).addEventListener('inView', animatePractice);
			checkWidgetsInView();
			if (typeof widgetInView[widget] != 'undefined' && !widgetInView[widget]) {
				_u.qS('#' + widget).classList.remove('active');
				window.removeEventListener('scroll', checkWidgetsInView);
				window.addEventListener('scroll', checkWidgetsInView);
			}
		}
		else {
			_u.qS('#' + widget).classList.add('inactive');
		}
	}		
	else if (widget == 'topSalarySpecialty') {	
		// HIGHEST PAID SPECIALTIES
		_v.userSpecRank = null;
		_u.qS('.specs .slry-card-high-item-wrap').innerHTML = '';
		_u.qS('.specs .slry-card-high-item-self').innerHTML = '';
		_u.qS('.specs').classList.remove('expanded','all','active');
		_u.qS('.specs').classList.add('all');
		
		if (_v.widgData[widget] != null && _v.widgData[widget].metrics != null && _v.widgData[widget].metrics.length > 0) {
			
			_u.qS('#' + widget).classList.remove('inactive');	
			
			if (!_v.labelsAppended) {
				_v.labelsAppended = true;
				_fn.getLabelsGeneric();
			}
			_fn.getLabels(_u.qS('#' + widget), _v.widgData[widget].level);
			
			let matchedSpec = null;			
			let topSpecArr = _v.widgData[widget].metrics;				
			let startIndex = 0;

			if (topSpecArr.length <=5) {
				_u.qS('.specs .slry-card-view-more').classList.add('inactive');
			}
			else {
				_u.qS('.specs .slry-card-view-more').classList.remove('inactive');
			}
			
			for (let x = startIndex; x < topSpecArr.length; x++) {
				let itemElem = document.createElement('div');
				itemElem.className = 'slry-card-high-item';
				if (topSpecArr[x].isSpecialityMatched) {
					_v.userSpecRank = topSpecArr[x].rank;
					matchedSpec = topSpecArr[x];
					itemElem.classList.add('active');
				}
				itemElem.innerHTML = '<div class="slry-card-high-rank">' + topSpecArr[x].rank + '</div><div class="slry-card-high-text">' + _m.specMap[topSpecArr[x].homePageId].specialty + '</div><div class="slry-card-high-salary">' + _fn.formatSalary(topSpecArr[x].avg_salary) + '</div>';
				_u.qS('.specs .slry-card-high-item-wrap').appendChild(itemElem);
			}
			
			if (_v.userSpecRank > 5) {
				let itemElem = document.createElement('div');
				itemElem.className = 'slry-card-high-item active';
				itemElem.innerHTML = '<div class="slry-card-high-rank">' + matchedSpec.rank + '</div><div class="slry-card-high-text">' + _m.specMap[matchedSpec.homePageId].specialty + '</div><div class="slry-card-high-salary">' + _fn.formatSalary(matchedSpec.avg_salary) + '</div>';
				_u.qS('.specs .slry-card-high-item-self').appendChild(itemElem);
				_u.qS('.specs .slry-card-high-item-self').classList.remove('inactive');
				_u.qS('.specs').classList.remove('all');
			}
						
			_u.qS('.specs .slry-card-view-more').removeEventListener('click', handleViewMore);
			_u.qS('.specs .slry-card-view-more').addEventListener('click', handleViewMore);
			
			widgetInView[widget] = false;
			_u.qS('#' + widget).removeEventListener('inView', animateTopSpecialty);
			_u.qS('#' + widget).addEventListener('inView', animateTopSpecialty);
			checkWidgetsInView();
			if (typeof widgetInView[widget] != 'undefined' && !widgetInView[widget]) {
				_u.qS('#' + widget).classList.remove('active');
				window.removeEventListener('scroll', checkWidgetsInView);
				window.addEventListener('scroll', checkWidgetsInView);
			}
			
		}
		else {
			_u.qS('#' + widget).classList.add('inactive');
		}
	}
	else if (widget == 'topSalaryIndividuals') {
		// HIGHEST PAID INDIVIDUALS			
		_u.qS('.slry-card.high.indiv .slry-card-high-item-wrap').innerHTML = '';
		
		if (_v.widgData[widget] != null) {				
			_u.qS('#' + widget).classList.remove('inactive');
			
			if (!_v.labelsAppended) {
				_v.labelsAppended = true;
				_fn.getLabelsGeneric();
			}
			_fn.getLabels(_u.qS('#' + widget), _v.widgData[widget].level);
		
			_v.widgData[widget].metrics.forEach(function(salObj, idx) {
				if (idx < 5) {
					let yrsStr = salObj.experience + '  Yrs Experience';
					let empStr = '';
					if (salObj.employed > 0) {
						empStr = 'Employed';
					} else {
						empStr = 'Self-employed';
					}
					let roundedSal = String(Math.round(salObj.salary / 100) * 100);
					roundedSal = '$' + roundedSal.replace(/(\d?\d\d)(\d\d\d$)/,',$1,$2').replace(/^,/,'');
					let itemElem = document.createElement('div');
					itemElem.className = 'slry-card-high-item';
					itemElem.innerHTML = '<div class="slry-card-high-rank">' + (idx+1) + '</div><div class="slry-card-high-hs"></div><div class="slry-card-high-text"><div class="slry-card-high-text-ln">' + yrsStr + '</div><div class="slry-card-high-text-ln">' + empStr + '</div></div><div class="slry-card-high-salary">' + roundedSal + '</div>';		
					_u.qS('.slry-card.high.indiv .slry-card-high-item-wrap').appendChild(itemElem);
				}
			});
			
			widgetInView[widget] = false;
			_u.qS('#' + widget).removeEventListener('inView', animateTopIndividuals);
			_u.qS('#' + widget).addEventListener('inView', animateTopIndividuals);
			checkWidgetsInView();
			if (typeof widgetInView[widget] != 'undefined' && !widgetInView[widget]) {
				_u.qS('#' + widget).classList.remove('active');
				window.removeEventListener('scroll', checkWidgetsInView);
				window.addEventListener('scroll', checkWidgetsInView);
			}
			
		}			
		else {
			_u.qS('#' + widget).classList.add('inactive');
		}
	}
	else if (widget == 'topSalaryDmac') {		
		// BEST PAYING CITIES
		if (_v.widgData[widget] != null && _v.widgData[widget].dmacs != null && _v.widgData[widget].dmacs.length > 0) {		
			_u.qS('#' + widget).classList.remove('inactive');
						
			if (!_v.labelsAppended) {
				_v.labelsAppended = true;
				_fn.getLabelsGeneric();
			}
			_fn.getLabels(_u.qS('#' + widget), _v.widgData[widget].level);				
	
			_v.userDmaRank = null;
			_u.qS('.locs .slry-card-high-item-wrap').innerHTML = '';
			_u.qS('.locs .slry-card-high-item-self').innerHTML = '';
			_u.qS('.locs').classList.remove('expanded','all','active');
			_u.qS('.locs').classList.add('all');
			
			if (_v.widgData[widget].dmacs.length <= 5) {
				_u.qS('.locs .slry-card-view-more').classList.add('inactive');
			} else {
				_u.qS('.locs .slry-card-view-more').classList.remove('inactive');
			}
			
			let matchedDmac = null;
			
			for (let x = 0; x < _v.widgData[widget].dmacs.length; x++) {
				let itemElem = document.createElement('div');
				itemElem.className = 'slry-card-high-item';
				if (_v.widgData[widget].dmacs[x].isMatchedDmac) {
					_v.userDmaRank = _v.widgData[widget].dmacs[x].rank;
					matchedDmac = _v.widgData[widget].dmacs[x];						
					itemElem.classList.add('active');
					itemElem.innerHTML = '<div class="slry-card-high-rank">' + _v.widgData[widget].dmacs[x].rank + '</div><div class="slry-card-high-text">' + _v.userLoc + '<div class="slry-card-high-salary">' + _fn.formatSalary(_v.widgData[widget].dmacs[x].avg_salary) + '</div></div><img class="slry-card-dma" src="//img.' + _u.getDomain() + 'medscapestatic.com/pi/features/salary-exp/dma/' + _v.widgData[widget].dmacs[x].dmacName.toLowerCase().replace(/,/g,'').replace(/ /g,'_') + '.jpg" />';
					if (_v.userDmaRank <= 9) {
						_u.qS('.locs .slry-card-high-item-wrap').appendChild(itemElem);						
					}
				} else {
					itemElem.innerHTML = '<div class="slry-card-high-rank">' + _v.widgData[widget].dmacs[x].rank + '</div><div class="slry-card-high-text">' + _v.widgData[widget].dmacs[x].dmacName + '<div class="slry-card-high-salary">' + _fn.formatSalary(_v.widgData[widget].dmacs[x].avg_salary) + '</div></div><img class="slry-card-dma" src="//img.' + _u.getDomain() + 'medscapestatic.com/pi/features/salary-exp/dma/' + _v.widgData[widget].dmacs[x].dmacName.toLowerCase().replace(/,/g,'').replace(/ /g,'_') + '.jpg" />';
					_u.qS('.locs .slry-card-high-item-wrap').appendChild(itemElem);
				}
			}
			
			if (_v.userDmaRank > 5) {
				let itemElem = document.createElement('div');
				itemElem.className = 'slry-card-high-item active';
				itemElem.innerHTML = '<div class="slry-card-high-rank">' + matchedDmac.rank + '</div><div class="slry-card-high-text">' + _v.userLoc + '<div class="slry-card-high-salary">' + _fn.formatSalary(matchedDmac.avg_salary) + '</div></div><img class="slry-card-dma" src="//img.' + _u.getDomain() + 'medscapestatic.com/pi/features/salary-exp/dma/' + matchedDmac.dmacName.toLowerCase().replace(/,/g,'').replace(/ /g,'_') + '.jpg" />';
				_u.qS('.locs .slry-card-high-item-self').appendChild(itemElem);
				_u.qS('.locs .slry-card-high-item-self').classList.remove('inactive');
				_u.qS('.locs').classList.remove('all');
			}
			
			_u.qS('.locs .slry-card-view-more').removeEventListener('click', handleViewMore);
			_u.qS('.locs .slry-card-view-more').addEventListener('click', handleViewMore);
			
			widgetInView[widget] = false;
			_u.qS('#' + widget).removeEventListener('inView', animateTopCities);
			_u.qS('#' + widget).addEventListener('inView', animateTopCities);
			checkWidgetsInView();
			if (typeof widgetInView[widget] != 'undefined' && !widgetInView[widget]) {
				_u.qS('#' + widget).classList.remove('active');
				window.removeEventListener('scroll', checkWidgetsInView);
				window.addEventListener('scroll', checkWidgetsInView);
			}
		
		}
		else {
			_u.qS('#' + widget).classList.add('inactive');
		}
	}
	else if (widget == 'avgBreakDownGender') {
		// GENDER BREAKDOWN
		if (_v.widgData[widget] != null && _v.widgData[widget].male.avg_salary != null && _v.widgData[widget].female.avg_salary != null) {				
			_u.qS('#' + widget).classList.remove('inactive');	
		
			if (!_v.labelsAppended) {
				_v.labelsAppended = true;
				_fn.getLabelsGeneric();
			}
			_fn.getLabels(_u.qS('#' + widget), _v.widgData[widget].level);
		
			_u.qS('.male .slry-card-gender-label-salary').innerHTML = _fn.formatSalary(_v.widgData[widget].male.avg_salary);
			_u.qS('.female .slry-card-gender-label-salary').innerHTML = _fn.formatSalary(_v.widgData[widget].female.avg_salary);
			
			widgetInView[widget] = false;
			_u.qS('#' + widget).removeEventListener('inView', animateGender);
			_u.qS('#' + widget).addEventListener('inView', animateGender);
			checkWidgetsInView();
			if (typeof widgetInView[widget] != 'undefined' && !widgetInView[widget]) {
				window.removeEventListener('scroll', checkWidgetsInView);
				window.addEventListener('scroll', checkWidgetsInView);
			}
		}
		else {
			_u.qS('#' + widget).classList.add('inactive');
		}
	}		
}

function fetchWidget(widget) {	
	return new Promise(function(resolve, reject) {
		_v.apiPending = true;
		_v.apiPromise = callSalApi(widget).then(function(widgData) {
			_v.pendingLoad--;
			_v.widgData[widget] = widgData.data[widget].widgetData;
			renderWidgets(widget);
			document.dispatchEvent(new CustomEvent('loadWidget'));
			resolve(_u.qS('#' + widget));
		})
		.catch(err => {
		  console.log(err);
		  _v.pendingLoad--;
		  _v.widgData[widget] = null;
		  _u.qS('#' + widget).classList.add('inactive');
		  document.dispatchEvent(new CustomEvent('loadWidget'));
		  resolve(_u.qS('#' + widget));
		});
	});
}

function lazyLoadWidg() {
	_v.widgNames.forEach(function(widget) {
		if (_v.widgPending[widget] == null) {
			if (_u.qS('#' + widget).offsetParent != null && _u.qS('#' + widget).getBoundingClientRect().top < window.innerHeight + 200  && _u.qS('#' + widget).getBoundingClientRect().bottom >= -200) {
					_v.pendingLoad++;
					_v.widgPending[widget] = true;
					fetchWidget(widget);
			}
		}
	});
}

function adsHeight() {
	_u.qS('.AdUnit').forEach((elem) => {
		if (elem.offsetParent != null) {
			let currHeight = elem.clientHeight;
			if (elem.getAttribute('id') == 'ads-pos-101') {
				currHeight = currHeight - 10; // Padding throwing off calculation for Pos 101
			}
			if (currHeight > 10) {
				elem.setAttribute('style','height: ' + currHeight + 'px');
				elem.classList.add('adsHeight');
			}
		}
	});
}

function resetWidg() {
	_v.widgNames.forEach(function(widget) {
		_u.qS('#' + widget).classList.remove('inactive');
	});
	
	widgetInView['avgBreakDownPractice'] = false;
	checkWidgetsInView();
	if (typeof widgetInView['avgBreakDownPractice'] != 'undefined' && !widgetInView['avgBreakDownPractice']) {
		_u.qS('#avgBreakDownPractice').classList.remove('active');
	}
	
	widgetInView['topSalarySpecialty'] = false;
	checkWidgetsInView();
	if (typeof widgetInView['topSalarySpecialty'] != 'undefined' && !widgetInView['topSalarySpecialty']) {
		_u.qS('#topSalarySpecialty').classList.remove('active');
	}
	
	widgetInView['topSalaryIndividuals'] = false;
	checkWidgetsInView();
	if (typeof widgetInView['topSalaryIndividuals'] != 'undefined' && !widgetInView['topSalaryIndividuals']) {
		_u.qS('#topSalaryIndividuals').classList.remove('active');
	}
	
	widgetInView['topSalaryDmac'] = false;
	checkWidgetsInView();
	if (typeof widgetInView['topSalaryDmac'] != 'undefined' && !widgetInView['topSalaryDmac']) {
		_u.qS('#topSalaryDmac').classList.remove('active');
	}
}

function loadWidgets(e) {
	
	_v.labelsAppended = false;

	resetWidg();
	
	adsHeight();
	// Keep track of current widget placement relative to viewport
	if (window.innerHeight - _u.qS('.slry-left-col').getBoundingClientRect().top > 0) {
		for (let x = 0; x < _u.qS('.slry-left-col').children.length; x++) {	
			if (_u.qS('.slry-left-col').children[x].offsetParent != null && (_u.qS('.slry-left-col').children[x].classList.contains('slry-card') || _u.qS('.slry-left-col').children[x].tagName.toLowerCase() == 'a') && _u.qS('.slry-left-col').children[x].getBoundingClientRect().top > 0 && window.innerHeight - _u.qS('.slry-left-col').children[x].getBoundingClientRect().top > 0) {
				_v.scrollElem = { 
					elem: _u.qS('.slry-left-col').children[x],
					fromBottom: window.innerHeight - _u.qS('.slry-left-col').children[x].getBoundingClientRect().top
				}
				break;
			}
		}
	}

	document.removeEventListener('loadWidget', followScroll);
	document.addEventListener('loadWidget', followScroll);
	document.removeEventListener('loadWidget', postWidgLoad);
	document.addEventListener('loadWidget', postWidgLoad);
	window.removeEventListener('collapse', followScroll);
	window.addEventListener('collapse', followScroll);
	
	if (typeof googletag != 'undefined' && typeof googletag.pubads != 'undefined' && !slotRenderBound) {
		slotRenderBound = true;
		googletag.pubads().addEventListener('slotRenderEnded', followScroll);
	}
	
	_v.widgData = {
		'avgLikeYou': null,
		'avgSalGrowth': null,
		'topSalarySpecialty': null,
		'avgBreakDownPractice': null,
		'topSalaryIndividuals': null,
		'topSalaryDmac': null,
		'avgBreakDownGender': null
	};
	_v.widgPending = {
		'avgLikeYou': null,
		'avgSalGrowth': null,
		'topSalarySpecialty': null,
		'avgBreakDownPractice': null,
		'topSalaryIndividuals': null,
		'topSalaryDmac': null,
		'avgBreakDownGender': null
	};
	lazyLoadWidg();
	window.removeEventListener('scroll', lazyLoadWidg);
	window.addEventListener('scroll', lazyLoadWidg);
	
	// Job Widget API Call and Render
	renderJobWidget();
}

// MAIN SALARY LOAD EVENT (Welcome + Filter Submit Handler)
document.addEventListener('loadSalaryPage', loadWidgets);

// Remove lazyLoading on Autoscroll
document.addEventListener('scrollStart', function() {
	// disable lazy load on auto scroll
	_v.isScrolling = true;
	window.removeEventListener('scroll', lazyLoadWidg);
});

document.addEventListener('scrollStop', function() {
	// re-enable lazy load after auto scroll
	_v.isScrolling = false;
	lazyLoadWidg();
	window.addEventListener('scroll', lazyLoadWidg);
});
